export default __webpack_public_path__ + "static/ProximaNova-Black-344d00f0d02d7fcb02cd04dcfc1a817f.woff2";